<template>
  <v-container fluid>
    <div class="d-flex justify-space-between mt-2 mb-5">
      <div class="d-flex flex-column" style="width: 50%">
        <p
          class="caption font-weight-bold blue-grey--text text--darken-3 pa-0 my-0 mr-1 "
        >
          {{ `${$t('routinesPrint.completed_finding_name')}:` }}

          <span class="caption blue-grey--text text--darken-3">
            {{ findingSituation }}
          </span>
        </p>
        <p
          class="caption font-weight-bold blue-grey--text text--darken-3 pa-0 my-0 mr-1 "
        >
          {{ `${$t('common.assignee_other')}:` }}

          <span class="caption blue-grey--text text--darken-3">
            {{ formatAssignees(finding.assignees) }}
          </span>
        </p>
        <p
          class="caption font-weight-bold blue-grey--text text--darken-3 pa-0 my-0 mr-1 "
        >
          {{ `${$t('routinesPrint.finding_link')}:` }}

          <span class="caption blue-grey--text text--darken-3">
            {{ findingLink }}
          </span>
        </p>
        <p
          class="caption font-weight-bold blue-grey--text text--darken-3 pa-0 my-0 mr-1 "
        >
          {{ `${$t('common.due_date')}:` }}
          <span class="caption blue-grey--text text--darken-3">
            {{ formatFindingDate(finding.dueDate) }}
          </span>
        </p>
        <p
          class="caption font-weight-bold blue-grey--text text--darken-3 pa-0 my-0 mr-1 "
        >
          {{ `${$t('routinesPrint.completed_finding_date')}:` }}
          <span class="caption blue-grey--text text--darken-3">
            {{ formatFindingDate(finding.completedAt) }}
          </span>
        </p>
      </div>

      <div class="d-flex flex-column">
        <StatusChip class="ml-2" :entity="finding" />
      </div>
    </div>
  </v-container>
</template>

<script>
import mixin from '@/mixins/mixin.vue'
import userMixin from '@/mixins/userMixin'
import { utils } from 'frontend-js-shared'
import StatusChip from '@/components/Core/StatusChip.vue'
import config from '@/config'

const revTypes = {
  quickAction: 'quickAction',
}

export default {
  name: 'DetailFindingPrint',

  mixins: [mixin, userMixin],

  data() {
    return {
      solutions: [],
      revTypes,
      isLoading: true,
    }
  },

  props: {
    finding: {
      type: Object,
      required: true,
    },
    findingNumber: Number,
    routineId: String,
  },

  components: {
    StatusChip,
  },

  computed: {
    findingSituation() {
      return `00${this.findingNumber} - ${this.finding.situation}`
    },

    findingLink() {
      const environmentURL = config.webAppURL
      return `${environmentURL}/routine-executions/${this.routineId}/${this.finding.id}`
    },
  },

  methods: {
    formatAssignees(assignees = []) {
      return assignees?.length > 1
        ? `${this.getFullName(assignees[0])}, +${assignees.length}`
        : this.getFullName(assignees[0])
    },

    formatFindingDate(date) {
      if (!date) return
      return utils.dates.formatDate(date, 'MMM D, YYYY')
    },
  },
}
</script>
